<wsb-modal
  (close)="activeModal.dismiss()"
  (dismiss)="activeModal.dismiss()"
  cancelButtonEnable="true"
  (primary)="activeModal.close(getData())"
  [title]="(unsubscribe ? 'contacts_list_unsubscribeservices_modal' : 'contacts_list_subscribeservices') | translate"
  [primaryDisabled]="false"
>
  <div body [@.disabled]="unsubscribe" [@modalWidth]="modalState">
    <div class="d-flex justify-content-between align-items-center" *ngFor="let campaign of emailCampaignList">
      <div class="mb-2 d-flex align-items-center" style="min-width: fit-content;">
        <wsb-ui-checkbox
          [checkboxId]="campaign.idCampaign"
          (checkedChange)="setEmailServiceStatus($event)"
          [(checked)]="campaign.selected"
          class="me-1 pt-1"
        ></wsb-ui-checkbox>
        <span class="ms-2">{{ campaign.title }}</span>
      </div>

      <div class="mb-2 me-3 d-flex align-items-center" [@enterAnimation] *ngIf="campaign.selected && !unsubscribe">
        <wsb-ui-checkbox [checkboxId]="'optin_' + campaign.idCampaign" [(checked)]="campaign.optin" class="me-1 pt-1"></wsb-ui-checkbox>
        <span class="ms-2 no-overflow" translate>services_choose_campaign_optin</span>
      </div>
    </div>
  </div>
</wsb-modal>
